// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"163":"3e890ded","290":"59bbd86e","748":"374f1cb9","960":"8030b510","983":"66c6f5e3"}[chunkId] + ".css";
};